module.exports = __webpack_public_path__ + "img/flag_purple_20dp.cb4f8bc8.png";